<template>
    <div class="toastholder">
        <div @click="remtoast(tostk)"  class="toastitem" v-for="tostv, tostk, tostix in $store.state.toasts" :key="tostix">
            <div style="color: black;">{{ tostv }}</div>
        </div>
    </div>
</template>
<script>

import ENUMS from './Enums';
// import LoadingComp from './LoadingComp.vue';
import { vget, query_sort } from '@/utility'


export default {
    name: ENUMS.VIEWS.QUERY,
    components: {

    }, mounted() {
        // var qthis = this

    }
    , data: function () {

        return {
            ENUMS: ENUMS
        }
    }, methods: {
        remtoast(x) {
            this.$store.commit("removeToast", x)
        },
        vget, query_sort
    }
}
</script>

<style scoped>
.toastholder {
    /* pointer-events: none; */
    position: fixed;
    display: flex;
    align-content: flex-end;
    /* align-items: flex-end; */
    justify-content: flex-start;
    flex-direction: column;
    flex-wrap: wrap;
    
    gap: 5px;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 15%;
    background-color: rgb(0 0, 0, 0);
    /* border: solid; */
    /* border-left-color: white;
    border-left: 0; */

    z-index: 900;

}


.toastitem {
    border-style: solid;
    border-color: black;
    border-width: 5px;
    margin-right: 10px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    background-color: rgb(145, 145, 145);
    color: black;
    width: 200px;
    min-height: 100px;
    /* border-radius: 10%; */
}
</style>